var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.357,
    height: 20,
    viewBox: "0 0 18.357 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3225",
    "data-name": "Group 3225",
    transform: "translate(-9216.916 -14238.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M9225.516,14241.108c-.9-1.543-2.442-.9-3.215-.9",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M9228.216,14250.622l-2.122,1.286-2.378-1.286-5.2,1.7a1.59,1.59,0,0,0-1.1,1.512v3.989h17.357v-3.976a1.59,1.59,0,0,0-1.114-1.517Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_465",
    "data-name": "Line 465",
    y2: 1.929,
    transform: "translate(9223.973 14248.822)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_466",
    "data-name": "Line 466",
    y1: 2.057,
    transform: "translate(9227.958 14248.822)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M9228.858,14242.779l-1.561.786a2.439,2.439,0,0,1-2.3.031l-1.8-.817-.685,1.415c0,2.371.428,5.4,3.514,5.4s3.512-3.028,3.512-5.4Z",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M9222.558,14244.065a3.553,3.553,0,0,1-.9-2.571c.385-1.958,2.915-2.508,3.215-2.572a4.646,4.646,0,0,1,2.957.386,3.529,3.529,0,0,1,2.186,2.187,3.438,3.438,0,0,1-.515,2.442",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_467",
    "data-name": "Line 467",
    y2: 3.471,
    transform: "translate(9231.43 14254.351)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_468",
    "data-name": "Line 468",
    y2: 3.471,
    transform: "translate(9220.63 14254.351)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e59aeca656a7b1d537423bdcad0cf3e6.svg";
export { ForwardRef as ReactComponent };